import React, { useMemo } from "react";
import { Cake, CircleDot, Phone, User } from "lucide-react";
import Card from "./Card";
import { displayValue, getInitials } from "./utils";
import textTranslator from "../../../../utils/useTextTranslator";
import Txt from "../../../Text";

const Text = ({ children, className, page = "APPOINTMENTS" }) => {
	return (
		<Txt page={page} className={className} keyName={page}>
			{children}
		</Txt>
	);
};

const AppointmentPatientCard = ({ appointment, formatDate, darkMode, arClass }) => {
	const patient = appointment?.patient || {};

	const fullName = useMemo(() => {
		const first = patient?.firstName || "";
		const last = patient?.lastName || "";
		const joined = `${first} ${last}`.trim();
		return joined || "-";
	}, [patient]);

	const initials = useMemo(() => getInitials(patient?.firstName, patient?.lastName), [patient]);

	return (
		<Card
			title={textTranslator("Patient", "APPOINTMENTS")}
			subtitle={textTranslator("Patient Information", "APPOINTMENTS")}
			icon={User}
			darkMode={darkMode}
			arClass={arClass}
		>
			<div className="flex items-center gap-4">
				<div
					className={
						darkMode
							? "h-20 w-20 rounded-full bg-white/10 text-white flex items-center justify-center text-3xl font-semibold"
							: "h-20 w-20 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center text-3xl font-semibold"
					}
				>
					{initials}
				</div>

				<div className="min-w-0">
					<div className="flex items-center gap-2">
						<div className={darkMode ? "text-2xl font-semibold text-white" : "text-2xl font-semibold text-slate-900"}>
							{fullName}
						</div>
					</div>
					<div className={darkMode ? "mt-1 flex items-center gap-2 text-sm text-gray-300" : "mt-1 flex items-center gap-2 text-sm text-slate-500"}>
						<span>{displayValue(patient?.age)} <Text>years old</Text></span>
						<CircleDot className="h-3 w-3 opacity-60" />
						<span>{patient?.birthday ? formatDate(patient.birthday) : "-"}</span>
					</div>
				</div>
			</div>

			<div className="mt-4 flex flex-wrap gap-2">
				{patient?.phone && (
					<div
						className={
							darkMode
								? "inline-flex items-center gap-2 rounded-lg border border-white/10 bg-white/5 px-3 py-1.5 text-sm text-gray-200"
								: "inline-flex items-center gap-2 rounded-lg border border-slate-100 bg-slate-50 px-3 py-1.5 text-sm text-slate-700"
						}
					>
						<Phone className="h-4 w-4" />
						{displayValue(patient?.phone)}
					</div>
				)}
				{patient?.birthday && (
					<div
						className={
							darkMode
								? "inline-flex items-center gap-2 rounded-lg border border-white/10 bg-white/5 px-3 py-1.5 text-sm text-gray-200"
								: "inline-flex items-center gap-2 rounded-lg border border-slate-100 bg-slate-50 px-3 py-1.5 text-sm text-slate-700"
						}
					>
						<Cake className="h-4 w-4" />
						{formatDate(patient.birthday)}
					</div>
				)}
			</div>
		</Card>
	);
};

export default AppointmentPatientCard;
